module.exports = __webpack_public_path__ + "img/img16.1906b1a2.png";